import { ISingleService } from "types";

export const uniqueOptionIds = (ids: string[]): string[] => Array.from(new Set(ids));

export const withOption = (prev: string[], id: string | undefined | null): string[] => {
  if (!id) {
    return prev;
  }
  if (prev.includes(id)) {
    return prev;
  }
  return [...prev, id];
};

export const withoutOption = (prev: string[], id: string | undefined | null): string[] => {
  if (!id) {
    return prev;
  }
  return prev.filter((el) => el !== id);
};

export const withReplacedCategory = (
  prev: string[],
  activeService: ISingleService | null | undefined,
  category: string,
  newId: string | undefined | null,
): string[] => {
  const base = activeService
    ? prev.filter((el) => {
        const option = activeService.options.find((opt) => opt.id === el);
        return !option || option.category !== category;
      })
    : prev;

  return withOption(base, newId);
};
